import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from '@helpers/axios';

const useScoringKey = (
  teamId: string,
  isScoringLink: boolean,
  handleNoScoringKeyTray: () => void
) => {
  const location = useLocation();
  const [userAuthorizedByScoringKey, setUserAuthorizedByScoringKey] =
    useState<boolean>(false);

  useEffect(() => {
    if (!isScoringLink) {
      return;
    }

    const queryParams = new URLSearchParams(location.search);
    const scoreDelegationKey = queryParams.get('key');

    if (!scoreDelegationKey) {
      setUserAuthorizedByScoringKey(false);
      handleNoScoringKeyTray();
      return;
    }

    axios
      .get(`/v2/teams/${teamId}/auth`, {
        headers: {
          'X-Slhd-Scoring-Key': scoreDelegationKey,
        },
      })
      .then((resp) => {
        if (resp?.data?.status !== 200) {
          setUserAuthorizedByScoringKey(false);
          return handleNoScoringKeyTray();
        }

        const responseScoringKey = resp?.data?.scoring_key;
        if (responseScoringKey) {
          setUserAuthorizedByScoringKey(true);
          localStorage.setItem('scoreDelegationKey', responseScoringKey);
        } else {
          setUserAuthorizedByScoringKey(false);
          handleNoScoringKeyTray();
        }
      })
      .catch(() => {
        setUserAuthorizedByScoringKey(false);
        handleNoScoringKeyTray();
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isScoringLink]);

  return userAuthorizedByScoringKey;
};

export default useScoringKey;
